import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import IframeResizer from "iframe-resizer-react";
import * as React from "react";
import { FC } from "react";

const enum fields {
    source = "source",
    iframeId = "iframeId",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.source]: string;
        [fields.iframeId]: string;
    };
}

export const IFrame: FC<OwnProps> = ({ fields }) => {
    return (
        <IframeResizer id={fields.iframeId || "pardotframe"} style={{ width: "100%", border: 0 }} src={fields.source} />
    );
};

const widgetModule: WidgetModule = {
    component: IFrame,
    definition: {
        group: "Basic",
        icon: "link-simple",
        fieldDefinitions: [
            {
                name: fields.source,
                fieldType: "Contextual",
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: true,
            },
            {
                name: fields.iframeId,
                fieldType: "Contextual",
                editorTemplate: "TextField",
                defaultValue: "pardotframe",
                tooltip: "Take care not to have two same IDs on one page",
            },
        ],
    },
};

export default widgetModule;
